import styled from 'styled-components';
import { motion } from 'framer-motion';

type CheckboxProps = {
  checked: boolean;
};

const StyledCheckbox = styled.div<CheckboxProps>`
  color: #320564;
  display: flex;
  border: 1px solid #320564;
  aspect-ratio: 1;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  height: 24px;
  width: 24px;

  &:hover {
    background: #ebe8ed;
  }
`;

const icon = {
  unchecked: {
    pathLength: 0,
    opacity: 0,
  },
  checked: {
    pathLength: 1,
    opacity: 1,
  },
};

export const Checkbox = (props: CheckboxProps) => {
  const { checked } = props;
  return (
    <StyledCheckbox checked={checked}>
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 10"
        animate={checked ? 'checked' : 'unchecked'}
      >
        <motion.path
          variants={icon}
          initial={false}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M1.5 5.8 4.643 9 12.5 1"
        />
      </motion.svg>
    </StyledCheckbox>
  );
};

export default Checkbox;
